import React, { useMemo } from "react";
import { useTable, usePagination } from 'react-table';
import '../style/ReactTab.css';

function ReactTab({results, request}) {
    const data = results;
    // Les headers des colones a afficher dans le tableau
    const columns = useMemo(
        () => [
            {
                Header: "Id",
                accessor: "referentialId"
            },
            {
                Header: "Libelle Fr",
                accessor: "libelleFr",
            },
            {
                Header: "Type",
                accessor: "type",
            },
            /*{
                Header: "Identifiant de Famille",
                accessor: "familleId",
            },
            {
                Header: "Parent",
                accessor: "parent",
            },
            {
                Header: "Identifiant de Parent",
                accessor: "parentId",
            },
            {
                Header: "État",
                accessor: "etat",
            },
            {
                Header: "Ordre",
                accessor: "ordre",
            },*/
            {
                Header: "Type de Modification",
                accessor: "modification",
            },
            {
              Header: "Changement",
              accessor: "changement",
            },
            {
                Header: "Date de Modification",
                accessor: "date",
            },
        ],
        []
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page, // Instead of using 'rows', we'll use page,
        // which has only the rows for the active page

        // The rest of these things are super handy, too ;)
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0 },
        },
        usePagination
    )
    // Si le résultat de la recherche est null
    if(data.length === 0){
        return (
            <div id="no-content">
                <h2>Aucun contenu</h2>
                <p>Il semblerait qu'aucune donnée ne corresponde à ce filtre. Veuillez réessayer avec un nouveau filtre.</p>
            </div>
        )
    }
    // console.log(data);
    //Sinon on affiche le tableau avec les valeurs
    return (
        <>
            <table id="referential_tab" {...getTableProps()}>
                <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                        ))}
                    </tr>
                ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                            })}
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <div id="pagination_div">
                <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                    {'<<'}
                </button>{' '}
                <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                    {'<'}
                </button>{' '}
                <button onClick={() => nextPage()} disabled={!canNextPage}>
                    {'>'}
                </button>{' '}
                <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                    {'>>'}
                </button>{' '}
                <span>
                    Page{' '}
                    <strong>
                        {pageIndex + 1} sur {pageOptions.length}
                    </strong>{' '}
                </span>
                <span>
                    | Aller à la page:{' '}
                    <input
                        type="number"
                        defaultValue={pageIndex + 1}
                        onChange={e => {
                            const page = e.target.value ? Number(e.target.value) - 1 : 0
                            gotoPage(page)
                        }}
                        style={{ width: '40px' }}
                    />
                </span>
                {' '}
                <div style={{display: "inline-block", marginRight: "20px"}}>
                    <span>
                        Montrer: {' '}
                    </span>
                    <select
                        value={pageSize}
                        onChange={e => {
                            setPageSize(Number(e.target.value))
                        }}
                    >
                        {[10, 20, 30, 40, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                {pageSize}
                            </option>
                        ))}
                    </select>
                </div>

                <div style={{display: "inline-block"}}>
                    <span>
                        Exports:
                    </span>
                    <a className="bouton-export" href={request}>CSV</a>
                </div>
            </div>
        </>
    );
}

export default ReactTab;